import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useLocalePath } from '@/hooks/useLocalePath';
import { Seo } from '@/components/Seo';
import type { JSX } from 'react';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  const path = useLocalePath();
  return (
    <>
      <Seo title={t('errors.notFound')} path="/404" noindex />
      <div className="rz-shell flex flex-col items-center justify-center gap-4 py-32 text-center">
        <h1 className="font-display text-2xl">{t('errors.notFound')}</h1>
        <p className="max-w-sm text-sm text-[var(--color-muted)]">{t('errors.notFoundBody')}</p>
        <Link to={path('/')} className="rz-button mt-2">{t('nav.home')}</Link>
      </div>
    </>
  );
}
